<template>
  <b-card>
    <pre-loading v-if="loading" />
    <b-list-group v-else>
      <list-item
        v-if="customer.customers_type"
        label-text="Müşteri Tipi"
        :value-text="customer.customers_type"
      />
      <list-item
        v-if="customer.ccode"
        label-text="Müşteri Kodu"
        :value-text="customer.ccode"
      />
      <list-item
        v-if="customer.company"
        label-text="Firma Adı"
        :value-text="customer.company"
      />
      <list-item
        v-if="customer.name"
        label-text="İlgili Kişi"
        :value-text="customer.name"
      />
      <list-item
        v-if="customer.phone"
        label-text="Telefon"
        :value-text="customer.phone"
      />
      <list-item
        v-if="customer.fax"
        label-text="Fax"
        :value-text="customer.fax"
      />
      <list-item
        v-if="customer.email"
        label-text="E-Posta"
        :value-text="customer.email"
      />
      <list-item
        v-if="customer.website"
        label-text="Web Site"
        :value-text="customer.website"
      />
      <list-item
        v-if="customer.tax_office"
        label-text="Vergi Dairesi"
        :value-text="customer.tax_office"
      />
      <list-item
        v-if="customer.tax_number"
        label-text="Vergi Numarası"
        :value-text="customer.tax_number"
      />
      <list-item
        v-if="customer.address"
        label-text="Adres"
        :value-text="customer.address"
      />
      <list-item
        v-if="customer.city"
        label-text="İl"
        :value-text="customer.city"
      />
      <list-item
        v-if="customer.district"
        label-text="İlçe"
        :value-text="customer.district"
      />
      <list-item
        v-if="customer.meet"
        label-text="Temas Tipi"
        :value-text="customer.meet"
      />
      <list-item
        v-if="customer.sector"
        label-text="Sektör"
        :value-text="customer.sector"
      />
      <list-item
        v-if="customer.kvkk_type"
        label-text="Kvkk İzini"
        :value-text="customer.kvkk_type"
      />
      <list-item
        v-if="customer.kvkk_status"
        label-text="Kvkk Durumu"
        :value-text="customer.kvkk_status"
      />
      <list-item
        v-if="customer.notes"
        label-text="Notlar"
        :value-text="customer.notes"
      />
      <list-item
        v-if="customer.username"
        label-text="Oluşturma"
        :value-text="customer.username"
      />
    </b-list-group>
  </b-card>
</template>
<script>
import { BCard, BListGroup } from 'bootstrap-vue'
import ListItem from '@/views/Services/CustomerCard/ListItem.vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'CustomerCard',
  components: {
    BCard,
    BListGroup,
    ListItem,
    PreLoading,
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    customer() {
      return this.$store.getters['customers/getCustomer']
    },
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
  },
  created() {
    this.getData(this.dataItem.id_customers)
  },
  methods: {
    getData(id) {
      this.$store.dispatch('customers/customerView', id)
        .then(response => {
          if (response.id) {
            this.loading = false
          }
        })
    },
  },
}
</script>
